import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { canAccess, userRoles } from "@/lib/constants";

export default function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) return <div className="p-10 label-cap">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  // Superuser must always be inside the admin console — bounce them there
  if (userRoles(user).includes("superuser")) return <Navigate to="/admin-console" replace />;
  if (roles && !canAccess(user, roles))
    return <div className="p-10 text-slate-700" data-testid="access-denied">You do not have access to this section.</div>;
  return children;
}
